import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Navbar2 from '../../components/Navbar2/Navbar2';
import img from '../../images/contact.jpg';

const ContactPage =() => {
    
    return(
        <Fragment>
            <Navbar2 hclass={'wpo-header-style-1'} />
            <PageTitle pageTitle={'Contact Us'} pagesub={'Contact'} img={img}/> 
            <Contactpage/>
            <Footer />
            <Scrollbar/>
        </Fragment>
    )
};
export default ContactPage;

